import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { BaseResource } from '../../types';
import { createSubtleIceSurface } from '../../theme/surfaces';
import { BaseResourceCard } from './BaseResourceCard';

const surfaceSx = createSubtleIceSurface(500, {});

interface BaseResourceMiniCardProps {
  resource: BaseResource;
  onRemove: (refundCost: boolean) => void;
}

export const BaseResourceMiniCard: React.FC<BaseResourceMiniCardProps> = React.memo(function BaseResourceMiniCard({
  resource,
  onRemove,
}) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <Box sx={{ ...surfaceSx, width: 270, p: 1.5, borderRadius: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography variant="subtitle2" sx={{ flex: 1, minWidth: 0 }} noWrap>
          {resource.name}
        </Typography>
        <IconButton size="small" onClick={() => setIsExpanded(true)} aria-label={`Expand ${resource.name}`}>
          <OpenInFullIcon fontSize="inherit" />
        </IconButton>
      </Box>
      <Dialog open={isExpanded} onClose={() => setIsExpanded(false)} maxWidth="sm" className="MemberDialog" sx={{ m: 0, p: 0, border: 0 }}>
        <DialogContent sx={{ m: 1, p: 0 }}>
          <BaseResourceCard
            resource={resource}
            onRemove={(refundCost) => { setIsExpanded(false); onRemove(refundCost); }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsExpanded(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
});
